export default function WalletIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      strokeLinejoin='round'
      strokeLinecap='round'
      stroke='currentColor'
      viewBox='0 0 24 24'
      aria-hidden='true'
      strokeWidth='2'
      fill='none'
      height='48'
      width='48'
    >
      <path d='M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1' />
      <path d='M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4' />
    </svg>
  )
}
